import { STORAGE_KEY_COMPLAINTS_SURVEY } from "@/types";

export default function shouldShowComplaintsSurvey(): boolean {
  const item = localStorage.getItem(STORAGE_KEY_COMPLAINTS_SURVEY);
  return !item;
}
